import React from 'react'
import { TypesHelper } from 'SRC/utils'
import PropTypes from 'prop-types'
import { isJsonString } from 'src/utils/Utils'
import useTranslation from 'next-translate/useTranslation'

const renderServiceAndServiceType = (service, serviceType) => {
  return (
    <div className='ads-list-item-description-services'>
      <span>{service.name}</span>
      <span>{serviceType.name}</span>
    </div>
  )

}

const Compatibilities = ({ compatibilities, t }) => {
  const categoryText = compatibilities[0].category.compatibilityTitle
    ? compatibilities[0].category.compatibilityTitle
    : compatibilities[0].category.title

  const brandText = compatibilities[0]?.brand?.name
  const productText = compatibilities[0]?.product?.model

  let compatibilityText = ''

  if (brandText && productText) {
    compatibilityText = `${brandText} ${productText}`
  } else if (brandText) {
    compatibilityText = brandText
  } else if (productText) {
    compatibilityText = productText
  } else {
    compatibilityText = categoryText
  }

  return (
    <div className='ads-list-item-description-compatibilities'>
      <span>{t('Za')}: {compatibilityText}</span>
    </div>
  )
}

const ServiceAndServiceType = ({ service, serviceType }) => {
  return renderServiceAndServiceType(service, serviceType);
}

export const GridView = ({
  specs,
  compatibilities,
  service,
  serviceType,
}) => {
  const { t } = useTranslation('common')
  const hasSpecs = TypesHelper.isNotEmptyArray(specs)

  const hasCompatibilities = Array.isArray(compatibilities) && compatibilities.length

  const hasServiceAndServiceType = service && serviceType

  return (
    <div className='ads-list-item-description'>
      {!hasSpecs && hasCompatibilities ? (
        <Compatibilities
          compatibilities={compatibilities}
          t={t}
        />
      ) : null}

      {!hasSpecs && !hasCompatibilities && hasServiceAndServiceType ? (
        <ServiceAndServiceType service={service} serviceType={serviceType} />
      ) : null}

      {hasSpecs ? (
        <div className='ads-list-item-description-specs'>
          {specs.map((item, index) => {
            if (item) {
              let itemValue = item.value
              if (isJsonString(item.value) && Array.isArray(JSON.parse(item.value))) {
                itemValue = JSON.parse(item.value).join(', ')
              }
              if (item.measure) itemValue += ` ${item.measure}`

              return [
                <span key={index} className='ads-list-item-description-specs-item'>
                  {itemValue}
                </span>
              ]
            } else {
              return null
            }
          })}
        </div>
      ) : null}
    </div>
  )
}

GridView.propTypes = {
  specs: PropTypes.arrayOf(PropTypes.object).isRequired,
  compatibilities: PropTypes.arrayOf(PropTypes.object),
  compatibilityBrands: PropTypes.array,
  compatibilitiesCount: PropTypes.number,
  compatibilityBrandsCount: PropTypes.number,
  service: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  serviceType: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
}

GridView.defaultProps = {
  specs: []
}
